<template>
  <div>
    <chip-component class="mb-1" v-if="statusDetail" :reason="getReason" :payload="statusDetailFormatted" :add-class="['chip_status100']"/>
    <chip-component class="mb-1" v-else v-for="(status, index) in getStatus" :reason="status && status.color == 'red' ? getReason : null" :key="index" :payload="status" :add-class="['chip_status100']"/>
  </div>
</template>

<script>
import ChipComponent from '@/arch/components/ChipComponent.vue'
import mixinOrderStatus from '@/mixins/mixinOrderStatus'

export default {
  name: 'DataTableChipStatus',
  components: { ChipComponent },
  mixins: [mixinOrderStatus],
  props: {
    value: {
      type: [String, Object, Array],
      default: null,
    },
    statusDetail:{
      default:null
    },
    options: {
      type: Object,
      default() {
        return {
          // eslint-disable-next-line no-unused-vars
          transform: (value, row) => value,
        }
      },
    },
  },
  computed: {
    getStatus() {
      let keys
      let payload = this.value      
      if (typeof payload != 'object') {
        payload = { [this.value] : null}
      }
      keys = Object.keys(payload)

      let status = [] 
      keys.forEach((key) => {
        let chip = this.getNewStatus(this.options.transform(key))
        status.push(chip)
      })
      return status
    },
    getReason() {
      let row = this.$attrs['row'];

      if(!row){
        return ''
      }
      // por enquanto só é tratado razão de cancelamento
      if(row.REASON_CANCEL){
        return row.REASON_CANCEL;
      }
      return false;
    },
    statusDetailFormatted(){
      let statusDetail = this.statusDetail;

      if(!statusDetail){
        return {};
      }
      
      return this.availableStatus[statusDetail.toUpperCase()]
    }
  },
}
</script>